import { useMutation } from '@tanstack/react-query';
import { actions } from 'api/actions';
import { SHUB_APP_DEF_ID } from 'config/apps';
import { useEffect, useRef } from 'react';
import { useAppStore } from 'stores/appStore';
import { useMockupStore } from 'stores/mockupStore';
import { GeneratedMockup } from 'types/mockups';
import { DuplexerEvent } from 'utils/duplexer';

export const useMockupGenerate = () => {
  const { metaSiteId } = useAppStore.getState();

  const selectedProducts = useAppStore((state) => state.selectedProducts);
  const mockups = useMockupStore((state) => state.mockups);
  const setMockups = useMockupStore((state) => state.setMockups);
  const setIsLoading = useMockupStore((state) => state.setIsLoading);

  const duplexer = useRef(
    new DuplexerEvent<GeneratedMockup>(`shub-mockups-${metaSiteId}`, 'mockup_updated', SHUB_APP_DEF_ID),
  );

  const { mutate } = useMutation({
    onMutate: () => {
      setMockups({});
      setIsLoading(true);
    },
    mutationFn: async () => {
      duplexer.current.subscribe((mockup) => {
        const _mockups = useMockupStore.getState().mockups;
        setMockups({ ..._mockups, [mockup.productId]: mockup });
      });
      await actions.uploadSiteMedia();
      await actions.generateMockups();
      return {};
    },
  });

  useEffect(() => {
    if (selectedProducts.every((productId) => productId in mockups)) {
      setIsLoading(false);
    }
  }, [selectedProducts, mockups, setIsLoading]);

  return { generateMockups: mutate };
};
